export const generatePublicUrl = (fileName) => {
  return `https://mentorxdata.s3.ap-south-1.amazonaws.com/${fileName}`;
};
export const generatePublicUrlLocal = (fileName) => {
  return `https://api.mentorx4u.com/public/${fileName}`;
};
